import { render, staticRenderFns } from "./Configuration.vue?vue&type=template&id=f6095ba8&"
import script from "./Configuration.vue?vue&type=script&lang=js&"
export * from "./Configuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6095ba8')) {
      api.createRecord('f6095ba8', component.options)
    } else {
      api.reload('f6095ba8', component.options)
    }
    module.hot.accept("./Configuration.vue?vue&type=template&id=f6095ba8&", function () {
      api.rerender('f6095ba8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Configuration.vue"
export default component.exports